import React, { FC } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { SubmitButton, TextInput } from 'components/atoms';
import { Field, Form } from 'react-final-form';
import { contactUsValidation, MIN_LENGTH_MESSAGE_CONTACT_US } from 'data/validators/contact-us';
import { API_CONTACT_US_ROUTE } from 'data/api-routes';
import { useFormSender } from 'hooks';

const ContactUsForm: FC = () => {
  const {
    onSubmit,
    status: { error, loading, success },
  } = useFormSender(API_CONTACT_US_ROUTE);
  const isSubmitted = success || loading;
  return (
    <Form
      onSubmit={onSubmit}
      validate={contactUsValidation}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Box py={3} />
          <Field name="name">
            {({ input, meta: { error, touched } }) => (
              <TextInput
                disabled={isSubmitted}
                {...input}
                type="text"
                error={error && touched}
                hintMessage={touched && error}
                required
                label={'Name'}
              />
            )}
          </Field>
          <Box py={4} />
          <Field name="email">
            {({ input, meta: { error, touched } }) => (
              <TextInput
                disabled={isSubmitted}
                {...input}
                required
                error={error && touched}
                hintMessage={touched && error}
                label={'Email'}
              />
            )}
          </Field>
          <Box py={4} />
          <Field name="message">
            {({ input, meta: { error, touched } }) => (
              <TextInput
                {...input}
                disabled={isSubmitted}
                required
                type="text"
                multiline
                error={error && touched}
                hintMessage={touched && error}
                label={'Your message'}
                rows={10}
                counter={MIN_LENGTH_MESSAGE_CONTACT_US}
              />
            )}
          </Field>
          <Box pb={3} />
          <SubmitButton disabled={submitting} error={error} success={success}>
            {loading && <CircularProgress size="30px" color="secondary" />}
            {success && 'Thank you for filling out your information!'}
            {error && 'Error message'}
            {!loading && !success && !error && 'Send'}
          </SubmitButton>
        </form>
      )}
    />
  );
};

export default ContactUsForm;
